// extracted by mini-css-extract-plugin
export default {"tableLarge":"DataTableDIR_tableLarge__2SRz1","dataTable":"DataTableDIR_dataTable__MnLhF","hiddenRow":"DataTableDIR_hiddenRow__62yU2"};